import Header from './includes/header';
import PlacesMap from './elements/map';
import BookingForm from './includes/booking-form';
import Slide from './elements/slide';
import Gallery from './elements/gallery';
import ModuleFactory from "./utilities/module-factory";

const modules = [
	Header,
	BookingForm,
	PlacesMap,
	Slide,
	Gallery
];

new ModuleFactory(modules);

